<template>
  <v-app style="background-color: white;">
    <div class="bckdiv">
      <v-container>
        <v-layout align-center justify-center style="margin-top:150px">
          <v-flex xs12 md8>
            <h1 class="white--text txt_my" style="text-align:center">CONTACT US</h1>
            <p class="white--text txt_my mt-3" style="text-align:center">
              Any questions or remarks? Just write us a message!
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-container>
          <v-layout wrap>
            <v-flex xs12 sm12 md4 lg4 style="padding-right: 5px;">
              <b-input-group prepend="👤" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input
                  style="background-color: #FAF8ED;"
                  v-model="form.name"
                  id="inline-form-input-username"
                  placeholder="Enter Your Name"
                ></b-form-input>
              </b-input-group>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4 style="padding-right: 5px;">
              <b-input-group prepend="✉" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input
                  type="email"
                  style="background-color: #FAF8ED;"
                  v-model="form.email"
                  id="inline-form-input-username"
                  placeholder="Enter Your Email Address"
                ></b-form-input>
              </b-input-group>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4>
              <b-input-group prepend="☎" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input
                  type="number"
                  style="background-color: #FAF8ED;"
                  v-model="form.mobileNo"
                  id="inline-form-input-username"
                  placeholder="Enter Your Mobile No"
                ></b-form-input>
              </b-input-group>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12>
              <b-form-textarea
                id="textarea"
                style="background-color: #FAF8ED;"
                v-model="form.comment"
                placeholder="Write something here..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </v-flex>
            <v-flex xs12>
              <v-btn
                :loading="loading"
                @click="onSubmit()"
                block
                style="border-radius: 20px !important;color: #FFFFFF;background-color: #F66F4D;"
                flat
              >
                S U B M I T
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-card style="border-radius: 0px !important;background-color: #FAF8ED;">
          <v-layout wrap>
            <v-flex xs12 sm12 md3 style="text-align: center;">
              <v-avatar size="x-large" style="font-size: 50px;background-color: #F66F4D;margin-top: -40px;">
                <v-icon icon="mdi-alarm" style="font-size: 40px;color: white;padding: 10px;">call</v-icon>
              </v-avatar>

              <h5 class="txt_my" style="padding-top: 30px;font-weight: bold;color: #444444;">PHONE (LANDLINE)</h5>

              <p class="txt_my" style="font-size: 14px;padding-top: 10px;">033-2674-0229 (Head Office) <br/> +91 8240495872 (Head Office) <br/> +91 9433319675 (City Office)</p>
            </v-flex>
            <v-flex xs12 sm12 md3 style="text-align: center;">
              <v-avatar size="x-large" style="font-size: 50px;background-color: #F66F4D;margin-top: -40px;">
                <v-icon icon="mdi-alarm" style="font-size: 40px;color: white;padding: 10px;">email</v-icon>
              </v-avatar>
              <h5 class="txt_my" style="padding-top: 30px;font-weight: bold;color: #444444;">EMAIL ADDRESSES</h5>

              <p class="txt_my" style="font-size: 14px;padding-top: 10px;">majumderspecial@gmail.com <br/> salesinfoms@gmail.com</p>
            </v-flex>
            <v-flex xs12 sm12 md3 style="text-align: center;">
              <v-avatar size="x-large" style="font-size: 50px;background-color: #F66F4D;margin-top: -40px;">
                <v-icon icon="mdi-alarm" style="font-size: 40px;color: white;padding: 10px;">apartment</v-icon>
              </v-avatar>
              <h5 class="txt_my" style="padding-top: 30px;font-weight: bold;color: #444444;">HEAD OFFICE</h5>

              <p class="txt_my" style="font-size: 14px;padding-top: 10px;">
                275, criper road, Dist: Hooghly, Konnagar, Dream apt.
                1st floor ( Opposite IDBI Bank ) Pin-712235,
              </p>
            </v-flex>
            <v-flex xs12 sm12 md3 style="text-align: center;">
              <v-avatar size="x-large" style="font-size: 50px;background-color: #F66F4D;margin-top: -40px;">
                <v-icon icon="mdi-alarm" style="font-size: 40px;color: white;padding: 10px;">location_city</v-icon>
              </v-avatar>
              <h5 class="txt_my" style="padding-top: 30px;font-weight: bold;color: #444444;">CITY OFFICE</h5>

              <p class="txt_my" style="font-size: 14px;padding-top: 10px;">
                1 R. N. Mukharjee Road, Shop No: 19, Ground Floor, Opp Lal Bazar, Martinburn Building, Kolkata-700001
              </p>
            </v-flex>
            <v-flex xs12 sm12 md12 style="text-align: center;">
              <div>
                <v-avatar size="x-large" style="font-size: 50px;background-color: #F66F4D;margin-top: 0px;">
                <v-icon icon="mdi-alarm" style="font-size: 40px;color: white;padding: 10px;">account_balance</v-icon>
              </v-avatar>
              <h5 class="txt_my" style="font-weight: bold;color: #444444;padding-top: 10px;">BANK DETAILS</h5>
              <img style="display: block;margin: auto;height: 200px;" src="../../assets/phonepe.jpeg" />
              <p class="txt_my" style="font-size: 14px;padding-top: 10px;">A/c Name: MAJUMDER SPECIAL<br/>A/c No: 0074102000009256<br/>IFSC: IBKL0000074<br/>IDBI - KONNAGAR BRANCH</p>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-container>
    </div>
    
    <div class="row" style="padding-bottom: 25px;">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <v-card>
          <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.7172426720203!2d88.34374857398953!3d22.701567628233708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89c9edac5e7a7%3A0x57a8cbfbc0b80c9d!2sMajumder%20Special!5e0!3m2!1sen!2sin!4v1718862744935!5m2!1sen!2sin"
        width="100%"
        height="350"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
        </v-card>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <v-card>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1842.0942494915064!2d88.34905204442748!3d22.5720522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277a5baabca5f%3A0xbe43dc306dbe663b!2sMartin%20Burn%20House!5e0!3m2!1sen!2sin!4v1720246145162!5m2!1sen!2sin" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </v-card>
      </div>
    </div>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      loading: false,
      form: {
        name: "",
        email: "",
        mobileNo: "",
        comment: ""
      }
    };
  },

  methods: {
    onSubmit() {
      if (this.form.name!=''&&this.form.mobileNo!=''&&this.form.email!='') {
        this.loading = true;
        this.axios
          .post(
            config.API + `Contacts`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNo: this.form.mobileNo,
              comment: this.form.comment,
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Thank you for your time. Our team will contact you soon.");
            this.loading = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.loading = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },
  }
};
</script>

<style scoped>
@import "../../HomeCss/home.css";

@import url("https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap");
@import url("https://fonts.googleapis.com/css?family=Anton&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Alice&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Josefin+Slab:ital,wght@0,100..700;1,100..700&display=swap");
</style>

<style scoped>
.bgclr {
  width: 100%;
  height: 350px;
  background-image: linear-gradient(#7b1fa2, #e91e63);
}
.txt_my {
  font-family: "Alice", serif !important;
}
.bckdiv {
  background-image: url("../../assets/aboutus.jpg");
  height: 300px;
  background-size: cover;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: "Space Mono", monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: "Space Mono", monospace;
  font-weight: bold;
}
.enquiry {
  font-family: "Bree Serif", serif;
}
.contact_tag {
  font-size: 16px;
}
.head-ofc p,
.branch-ofc p {
  font-size: 18px;
  font-weight: 500;
}
.head-ofc,
.branch-ofc {
  margin: 15px;
  padding: 30px;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .help {
    padding-right: 0px !important;
  }
}
</style>
